import {SoopUiSwiper} from '@/components/ui';
import {
  BroadcastLayout,
  BroadcastType,
} from '@/components/main/common/Broadcast';
import {VOD_CONTEXT_MENU} from '@/constants/main';
import useListViewLog from '@/components/main/MyPlus/hooks/useListViewLog';
import {useEffect} from 'react';
import {BROADCAST_TYPES} from '@/constants';

const CinetyDefaultTemplate = ({itemList, useSlider, log = {}}) => {
  const {startObserve, endObserve} = useListViewLog(
    {
      path1: 'popular',
      path2: 'cinety',
      listType: 'VOD',
      selector: '.cinety_list',
    },
    itemList,
  );

  const renderItem = () => {
    return itemList.map((item) => (
      <li data-type='cBox' key={item.broadcastId}>
        <BroadcastLayout
          broadcastType={BROADCAST_TYPES.VOD}
          vodType='cinety'
          duration={item.duration}
          broadcastId={item.broadcastId}
          categoryName={item.categoryName}
          categoryTags={item.categoryTags}
          categoryNo={item.category}
          vodCategoryNo={item.vodCategory}
          allowsAdult={
            Number(item.grade) === 19 && Number(item.category) === 30000
          }
          hashTags={item.hashTags}
          hasBadge={true}
          thumbnailUrl={item.thumbnailSrc}
          title={item.title}
          userId={item.userId}
          userNickname={item.userNickname}
          viewCount={item.viewCount}
          createdDate={item.registerDate}
          isCinety={true}
          profileImageUrl={item.adminProfileImg}
          log={{
            data: {
              path1: 'popular',
              path2: 'list',
              path3: 'cinety',
              ...(item.category && {exCategoryNo: item.category}),
              ...log,
            },
          }}
          contextMenu={{menuList: VOD_CONTEXT_MENU}}>
          <BroadcastType.Vod />
        </BroadcastLayout>
      </li>
    ));
  };

  useEffect(() => {
    startObserve();
    return () => endObserve();
  }, [itemList]);

  return (
    <>
      {useSlider && (
        <div className='cBox_slide cinety_list'>
          <SoopUiSwiper
            swiperClass={`cBox_list`}
            options={{loop: itemList.length > 6}}
            maxSlidesPerView={6}
            otherMaxSlidesResolution={[
              {max: 1623, slidePerView: 6},
              {max: 1202, slidePerView: 5},
              {max: 1000, slidePerView: 4},
              {max: 751, slidePerView: 3},
              {max: 496, slidePerView: 2},
              {max: 0, slidePerView: 1},
            ]}
            swiperTag={'ul'}>
            {renderItem()}
          </SoopUiSwiper>
        </div>
      )}
      {!useSlider && (
        <div className='cBox-list'>
          <ul>{renderItem()}</ul>
        </div>
      )}
    </>
  );
};

export default CinetyDefaultTemplate;
